<template>
  <div>
    <div v-if="!active" class="shop-fullscreen-notification">
      <p>
        <i class="far fa-times-circle" />&nbsp;
        Sorry, our shop is currently unavailable.
      </p>
    </div>
    <router-view
      v-if="active"
      :buyers="buyers"
      :seller-logo-url="sellerLogoUrl"
      :stripe-account-id="stripeAccountId"
      :stripe-api-key="stripeApiKey"
      :logged-in="loggedIn"
      :enable-new-landing="enableNewLanding"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseShop',
  components: {},
  props:{
    buyers: { type: String, required: false, default: undefined },
    sellerPid: { type: String, required: true },
    sellerLogoUrl: { type: String, required: true },
    stripeAccountId: { type: String, required: false, default: undefined },
    stripeApiKey: { type: String, required: true },
    active: { type: Boolean, required: true },
    loggedIn: { type: Boolean, required: true, default: false },
    enableNewLanding: { type: String, required: true },
  },
  created() {
    if (this.active) {
      this.$store.dispatch('setSeller', this.sellerPid);
      this.$store.dispatch('resumeCart');

      let vm = this;
      window.addEventListener('focus', function() {
        vm.$store.dispatch('refreshCart');
      });

      let buyers = JSON.parse(this.buyers);

      if (buyers.length) {
        let buyer = buyers[0];
        vm.$store.commit('setBuyer', buyer);
      }
    }
  },
};
</script>
